var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 10,
    fill: "#F0F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4877 28.4571C34.3306 28.0108 34.0389 27.6243 33.6528 27.3508C33.2668 27.0773 32.8054 26.9304 32.3322 26.9302H30.5608C30.0583 26.9317 29.5739 27.1184 29.2005 27.4547C28.8271 27.791 28.5909 28.2533 28.5371 28.7529C28.4833 29.2526 28.6158 29.7545 28.909 30.1626C29.2023 30.5706 29.6358 30.8562 30.1265 30.9645L32.8191 31.5542C33.37 31.6745 33.8571 31.9942 34.1866 32.4518C34.5161 32.9094 34.6648 33.4727 34.6041 34.0334C34.5434 34.594 34.2776 35.1124 33.8578 35.489C33.438 35.8655 32.8939 36.0735 32.33 36.0731H30.8054C30.3328 36.0733 29.8718 35.927 29.4858 35.6544C29.0998 35.3818 28.8078 34.9962 28.65 34.5508M31.5711 26.9302V24.6445M31.5711 38.3588V36.0731M35.93 50.8548V38.8548C35.93 38.0971 36.231 37.3703 36.7668 36.8345C37.3026 36.2987 38.0293 35.9977 38.7871 35.9977C39.5449 35.9977 40.2716 36.2987 40.8074 36.8345C41.3432 37.3703 41.6442 38.0971 41.6442 38.8548V45.1405H46.2157C47.4281 45.1405 48.5908 45.6222 49.4482 46.4795C50.3055 47.3368 50.7871 48.4995 50.7871 49.712V50.8548",
    stroke: "#54D4BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5729 41.8606C29.4641 41.8603 27.4056 41.2163 25.6726 40.0145C23.9397 38.8128 22.6149 37.1107 21.8754 35.1357C21.1359 33.1608 21.0169 31.0071 21.5344 28.9628C22.0519 26.9184 23.1811 25.0807 24.7711 23.6954C26.3612 22.3101 28.3362 21.4432 30.4322 21.2106C32.5282 20.9781 34.6452 21.3909 36.5003 22.3939C38.3553 23.397 39.8599 24.9424 40.813 26.8236C41.766 28.7048 42.1221 30.8322 41.8335 32.9212",
    stroke: "#54D4BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_6270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInvest);
export default __webpack_public_path__ + "static/media/Icons-invest.22f0a48a1c897fb2dc214e8268e3c3af.svg";
export { ForwardRef as ReactComponent };